module.exports = __webpack_public_path__ + "c3070cec838c8e644d33a5103c7cf284.pdf";